var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 12,
    r: 11,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.52 8.13399L11.4431 5.12382C11.3074 5.0426 11.155 5 11 5C10.845 5 10.6926 5.0426 10.5569 5.12382L5.48 8.13524C5.33501 8.2212 5.21398 8.34777 5.12955 8.50172C5.04512 8.65568 5.00038 8.83138 5 9.01047V14.9895C5.00038 15.1686 5.04512 15.3443 5.12955 15.4983C5.21398 15.6522 5.33501 15.7788 5.48 15.8648L10.5569 18.8762C10.6926 18.9574 10.845 19 11 19C11.155 19 11.3074 18.9574 11.4431 18.8762L16.52 15.8648C16.665 15.7788 16.786 15.6522 16.8705 15.4983C16.9549 15.3443 16.9996 15.1686 17 14.9895V9.01109C16.9999 8.83168 16.9553 8.6556 16.8709 8.50128C16.7864 8.34697 16.6652 8.2201 16.52 8.13399ZM11 5.99905L15.635 8.74977L11 11.5005L6.365 8.74977L11 5.99905ZM5.92308 9.625L10.5385 12.362V17.7253L5.92308 14.9902V9.625ZM11.4615 17.7253V12.3645L16.0769 9.625V14.9877L11.4615 17.7253Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisual);
export default __webpack_public_path__ + "static/media/visual.7b345ffd72d73472c9fc639be5c2a5ce.svg";
export { ForwardRef as ReactComponent };